import api from 'api';

export const loadBriefTable = api('POST /api/influencers-briefs/grid');

export const loadBrief = api('GET /api/influencers-briefs/:id');

export const createBrief = api('POST /api/influencers-briefs');

export const updateBrief = api('PUT /api/influencers-briefs/:id');

export const deleteBrief = api('POST /api/influencers-briefs/:id/delete');
